import React from 'react';
import { useComponentRegistry } from './ComponentRegistryContext';

const ComponentRenderer = ({ componentName, defaultComponent: DefaultComponent, props }) => {
    const { components } = useComponentRegistry();

    const CustomComponent = components?.[componentName];
    return CustomComponent ? <CustomComponent {...props} /> : <DefaultComponent {...props} />;
};

export default ComponentRenderer;
